import { render, staticRenderFns } from "./PremiumLoadings.vue?vue&type=template&id=38148d68"
import script from "./PremiumLoadings.vue?vue&type=script&lang=js"
export * from "./PremiumLoadings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports